import React from 'react';

import ChoiceButtonContents from './ChoiceButtonContents';
import { useAnimationStageContext } from './AnimationStageContext';

const CursorChoiceButton = () => {
  const { stageKey, getSelectedCursorChoice } = useAnimationStageContext();

  if (!stageKey) {
    return null;
  }

  const { label, icon } = getSelectedCursorChoice();

  return (
    <ChoiceButtonContents label={label} id={`${stageKey}-cursor-choice-contents`}>
      {icon}
    </ChoiceButtonContents>
  );
};

export default CursorChoiceButton;
